<template lang="pug">
  .operator-table__table.scroll-fix-table.open-table
    vue-custom-scrollbar(
    class="table-wrapper"
      :settings="settings"
    )
      table.table
        thead.table__head
          tr.table__row
            th.table__cell(v-for="head in tab_head")
              .table__cell-content {{ head.title }}
            th.table__cell.fixed
              .table__cell-content

        tbody.table__body
          tr.table__row(v-for="item in tab_data")
            td.table__cell
              .table__cell-content  {{item.name}}
            td.table__cell
              .table__cell-content  {{item.passport}}
            td.table__cell
              .table__cell-content {{item.date}}
            td.table__cell
              .table__cell-content {{item.place}}
            td.table__cell
              .table__cell-content {{item.address}}
            td.table__cell.fixed
              .table__cell-content

</template>
<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  name: "reports-table",
  props: ["tab_data", "tab_head"],
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      settings: {
        useBothWheelAxes: true
      }
    };
  }
};
</script>
